import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess11725Status: 'idle',
    startProcess11725Error: undefined as any,
    loadUserParamsProcess11725Status: 'idle',
    loadUserParamsProcess11725Error: undefined as any,

    process11725List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess11725 = createAsyncThunk('process11725Slice/startProcess11725', async ({ process11725 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess11725/`,
        prepareData(process11725),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess11725Status } = getState().process11725Slice
        return startProcess11725Status !== 'pending'
    }
})

export const loadUserParamsProcess11725 = createAsyncThunk('process11725Slice/loadUserParamsProcess11725', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess11725/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess11725Status } = getState().process11725Slice
        return loadUserParamsProcess11725Status !== 'pending'
    }
})

const Process11725Slice = createSlice({
    name: 'process11725Slice',
    initialState,
    reducers: {
        resetstartProcess11725: (state) => {
            state.job = undefined
            state.startProcess11725Error = undefined
        },
        resetstartProcess11725Error: (state) => {
            state.startProcess11725Error = undefined
        },
        resetloadUserParamsProcess11725: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess11725Error = undefined
        },
        resetloadUserParamsProcess11725Error: (state) => {
            state.loadUserParamsProcess11725Error = undefined
        },
        removeFromProcess11725ListById: (state, action) => {
            state.process11725List = state.process11725List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess11725ListByIds: (state, action) => {
            state.process11725List = state.process11725List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process11725List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess11725Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process11725List = []
            state.startProcess11725Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess11725.pending, (state) => {
            state.startProcess11725Status = 'pending'
            state.startProcess11725Error = undefined
        })
        builder.addCase(startProcess11725.fulfilled, (state, action) => {
            state.startProcess11725Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.job = newItem
            }
        })
        builder.addCase(startProcess11725.rejected, (state, action) => {
            state.startProcess11725Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess11725Error = action.error.message
            } else {
                state.startProcess11725Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess11725.pending, (state) => {
            state.loadUserParamsProcess11725Status = 'pending'
            state.loadUserParamsProcess11725Error = undefined
        })
        builder.addCase(loadUserParamsProcess11725.fulfilled, (state, action) => {
            state.loadUserParamsProcess11725Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultValues = newItem
            }
        })
        builder.addCase(loadUserParamsProcess11725.rejected, (state, action) => {
            state.loadUserParamsProcess11725Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess11725Error = action.error.message
            } else {
                state.loadUserParamsProcess11725Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess11725,
    resetstartProcess11725Error,
    resetloadUserParamsProcess11725,
    resetloadUserParamsProcess11725Error,
    removeFromProcess11725ListById,
    removeFromProcess11725ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process11725Slice.actions
export default Process11725Slice.reducer
